 "use client";

import { useEffect, DependencyList } from 'react';

/**
 * A hook that debounces the execution of an effect.
 * The effect will only run after the specified delay has passed since the last dependency change.
 * 
 * @param effect - The effect function to debounce
 * @param delay - The debounce delay in milliseconds
 * @param deps - The dependency array for the effect
 */
export function useDebouncedEffect(
  effect: () => void | (() => void),
  delay: number,
  deps: DependencyList
): void {
  useEffect(() => {
    const handler = setTimeout(() => {
      effect();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
}

